import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import FingerprintJS from "@fingerprintjs/fingerprintjs";
export default function getVisitorId() {
  return _getVisitorId.apply(this, arguments);
}

function _getVisitorId() {
  _getVisitorId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var fp, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return FingerprintJS.load();

          case 2:
            fp = _context.sent;
            _context.next = 5;
            return fp.get();

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result.visitorId);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getVisitorId.apply(this, arguments);
}